import { env } from '@/env';

/**
 * «My Boards» del backgammon (Luca, I-343/I-346; ADR-0191 `accepted`, contratto `fronti/qgammon/my-boards.md`): acceso SOLO
 * col flag suo (`VITE_FEATURE_BACKGAMMON_MY_BOARDS_ENABLED`) in AND col backgammon acceso nella build. Stesso schema di
 * `sitngoBackgammonAcceso` (`lib/limulo/sitngoAcceso.ts`).
 * 🔴 UN predicato, un lettore oggi (l'elenco delle schede, `components/backgammon/lobbySections.ts`, Hub e `/backgammon`
 * insieme) e, dal T1, chi offre il gesto «Salva» in partita, replay e spettatore: due copie divergerebbero, e un bottone
 * porterebbe a una sezione che non c'e'. Il ruolo `beta` non si ricontrolla qui: chi arriva alle schede del backgammon
 * l'ha gia' (`RoleGate` sulla rotta, `showQgammon` sulla Hub).
 * ⚠️ Non chiede Limulo: le rotte dei board sono di QGammon, col Bearer come il resto della sezione (ADR-0191 §9). La sfida
 * da un board (T2) avra' la sua serratura, quella della sfida di piattaforma, dentro il foglio.
 * 🔴 Spento in TUTTI i file env, `.env.staging` compreso, per tutto il T0 (dati finti, niente rete).
 */
export function myBoardsAcceso(): boolean {
  return env.featureBackgammonMyBoardsEnabled && env.featureBackgammonEnabled;
}

/**
 * «Sfida un amico da qui» (la partita da un board, ADR-0191 §6): e' il T2 (Q4, G1, P1) e NON c'e'. 🔴 SPENTO, e non per il flag di
 * My Boards: il foglio e la scheda usano ancora amici e tempi FINTI (`useSfidaDaBoard`) e «Invia» chiude senza mandare niente — a
 * My Boards acceso un tester crederebbe di aver sfidato un amico. Finche' il T2 non cabla la sfida vera, il bottone e il foglio
 * NON si montano (la nota onesta per una posizione non giocabile resta). Il codice T0 del foglio resta nel repo per il T2, che
 * sostituisce questa funzione col suo predicato (lo scenario del server non basta: serve anche la sfida di piattaforma).
 */
export function sfidaDaBoardAcceso(): boolean {
  return false;
}
